import {err} from 'framework';
import type {Result, UseCase, ValidationError} from 'framework';
import type {NutritionPlan} from '../../domain/nutrition-plan';
import type {NutritionPlanError} from '../../domain/errors';
import type {
  CreateNutritionPlanInput,
  NutritionPlanRepository,
} from '../ports/nutrition-plan.repository';
import type {CreateNutritionPlanDataValidator} from '../validators/create-nutrition-plan-data.validator';

export class CreateNutritionPlan implements UseCase<[CreateNutritionPlanInput], NutritionPlan> {
  constructor(
    private readonly repository: NutritionPlanRepository,
    private readonly validator: CreateNutritionPlanDataValidator,
  ) {}

  execute(
    input: CreateNutritionPlanInput,
  ): Promise<Result<NutritionPlan, NutritionPlanError | ValidationError>> {
    const validated = this.validator.validate(input);
    if (!validated.ok) {
      return Promise.resolve(err(validated.error));
    }
    return this.repository.create(validated.data);
  }
}
